var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 10H15.125C14.5614 10 14.0209 10.2318 13.6224 10.6444C13.2239 11.0569 13 11.6165 13 12.2V29.8C13 30.3835 13.2239 30.9431 13.6224 31.3556C14.0209 31.7682 14.5614 32 15.125 32H27.875C28.4386 32 28.9791 31.7682 29.3776 31.3556C29.7761 30.9431 30 30.3835 30 29.8V16.6M23.625 10L30 16.6M23.625 10L23.625 16.6H30M25.75 22.1H17.25M25.75 26.5H17.25M19.375 17.7H17.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconDoc);
export default __webpack_public_path__ + "static/media/button-icon-doc.2d47fd115c082346805f819f5de2ba3d.svg";
export { ForwardRef as ReactComponent };